<section>
  <div class="bg-black p-4 tablet:p-5 desktop:p-6">
    <h3 class="font-headline text-white text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3">
      {{ 'components.subscriptionCalculations.youSelected' | scTranslate | async }}
    </h3>
  </div>
  <dl
    class="bg-white p-4 tablet:p-5 desktop:p-6"
    aria-live="polite"
    aria-atomic="true"
    aria-label="Subscription selected options and total price"
  >
    @if (dataBundle()) {
      <div class="flex justify-between mb-2 text-mobileMd tablet:text-tabletMd">
        <dt>{{ dataBundle().displayName }}</dt>
        <dd>{{ dataBundle().subscriptionPrice - dataBundle().discountSize | currency }}</dd>
      </div>
    }
    @if (dataCeilingEnabled()) {
      <div class="flex justify-between bg-neutral100 p-1 mb-2 text-mobileMd tablet:text-tabletMd">
        <div class="flex items-center">
          <sc-svg name="plus" size="w-5 h-5" class="mr-1"></sc-svg>
          <dt>
            {{ 'components.dataExtras.dataCeilingTitle' | scTranslate | async }}
          </dt>
        </div>
        <dd>{{ dataCeilingBundle()?.subscriptionPrice | currency }}</dd>
      </div>
    }
    @if (speedUpgradeEnabled()) {
      <div class="flex justify-between bg-neutral100 p-1 mb-2 text-mobileMd tablet:text-tabletMd">
        <div class="flex items-center">
          <sc-svg name="plus" size="w-5 h-5" class="mr-1"></sc-svg>
          <dt>
            {{ 'components.dataExtras.speedUpgradeTitle' | scTranslate | async }}
          </dt>
        </div>
        <dd>{{ speedUpgradeBundle()?.subscriptionPrice | currency }}</dd>
      </div>
    }
    @if (voiceBundle()) {
      <div class="flex justify-between mb-2 text-mobileMd tablet:text-tabletMd">
        <dt>{{ voiceBundle().displayName }}</dt>
        <dd>{{ voiceBundle().subscriptionPrice - voiceBundle().discountSize | currency }}</dd>
      </div>
    }
    @if (voiceCeilingEnabled()) {
      <div class="flex justify-between bg-neutral100 p-1 mb-2 text-mobileMd tablet:text-tabletMd">
        <div class="flex items-center">
          <sc-svg name="plus" size="w-5 h-5" class="mr-1"></sc-svg>
          <dt>
            {{ 'components.voiceExtras.voiceCeilingTitle' | scTranslate | async }}
          </dt>
        </div>
        <dd>{{ voiceCeilingBundle()?.subscriptionPrice | currency }}</dd>
      </div>
    }
    @if (internationalVoiceEnabled()) {
      <div class="flex justify-between bg-neutral100 p-1 mb-2 text-mobileMd tablet:text-tabletMd">
        <div class="flex items-center">
          <sc-svg name="plus" size="w-5 h-5" class="mr-1"></sc-svg>
          <dt>
            {{ 'components.internationalVoice.title' | scTranslate | async }}
          </dt>
        </div>
        <dd>{{ internationalVoiceBundle()?.subscriptionPrice | currency }}</dd>
      </div>
    }

    <div
      class="font-semibold tablet:font-semibold text-mobileMd tablet:text-tabletMd border-t border-[#F1EDED]"
    >
      <div
        class="font-headline text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 flex justify-between py-4"
      >
        <div>
          {{ 'components.subscriptionCalculations.nextMonthCost' | scTranslate | async }}
        </div>
        <data value="{{ totalPrice() }}">{{ totalPrice() | currency }}</data>
      </div>
      <div class="flex justify-between pt-4 border-t border-[#F1EDED]">
        <div>
          {{ 'components.subscriptionCalculations.effectiveDate' | scTranslate | async }}
        </div>
        <time [attr.datetime]="effectiveDate().toISOString()">{{ effectiveDate() | scDate }}</time>
      </div>
    </div>
  </dl>
</section>
